const ALLOWED = new Set(["B", "STRONG", "I", "EM", "U", "S", "STRIKE", "SPAN", "FONT", "BR", "DIV", "P", "MARK"]);
const STYLE_OK = /^(color|background-color|font-size|font-weight|font-style|text-decoration|text-decoration-line)$/i;

export const escHtml = (s = "") => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>");

export const isHtml = (v) => typeof v === "string" && /<\/?(b|i|u|s|strike|span|font|br|div|p|mark|strong|em)\b/i.test(v);

function clean(node) {
  [...node.childNodes].forEach((ch) => {
    if (ch.nodeType === 3) return;
    if (ch.nodeType !== 1 || !ALLOWED.has(ch.tagName)) {
      if (ch.nodeType === 1) { clean(ch); while (ch.firstChild) node.insertBefore(ch.firstChild, ch); }
      node.removeChild(ch);
      return;
    }
    [...ch.attributes].forEach((a) => {
      if (a.name === "style") {
        const kept = a.value.split(";").map((d) => d.trim()).filter((d) => STYLE_OK.test(d.split(":")[0].trim()) && !/url\(|expression/i.test(d));
        if (kept.length) ch.setAttribute("style", kept.join("; ")); else ch.removeAttribute("style");
      } else if (!["data-cid", "color", "size"].includes(a.name)) ch.removeAttribute(a.name);
    });
    clean(ch);
  });
}

export function sanitizeHtml(html) {
  const t = document.createElement("template");
  t.innerHTML = html || "";
  clean(t.content);
  const d = document.createElement("div");
  d.appendChild(t.content);
  return d.innerHTML;
}

export const toHtml = (v) => (isHtml(v) ? sanitizeHtml(v) : escHtml(v ?? ""));

export function htmlToText(v) {
  if (!isHtml(v)) return v || "";
  const d = document.createElement("div");
  d.innerHTML = sanitizeHtml(v).replace(/<br\s*\/?>/gi, "\n").replace(/<\/(div|p)>/gi, "\n");
  return (d.textContent || "").replace(/\n+$/, "");
}
